<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <span class="back" @click="$router.go(-1)"
                ><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span
            >
            <div class="section">
                <div class="license">
                    <dl>
                        <dt>
                            <div class="license_area">
                                <input
                                    type="file"
                                    class="uploadfile"
                                    ref="inputer"
                                    @change="chooseFile"
                                />
                                <img v-if="usccUrl" :src="usccUrl" alt="" />
                                <img
                                    v-else
                                    src="@/assets/images/realName/license.png"
                                    alt=""
                                />
                            </div>
                            <h6>(上传后可自动识别执照信息)</h6>
                        </dt>
                        <dd>
                            <div class="license_title">
                                认证资料（*请上传彩色原件或加盖公章的复印件）
                            </div>
                            <div class="des">
                                <p>
                                    *格式要求：原件照片、扫描件、支持.jpg、.jpeg、.png、<br />.bmp格式照片，大小不超过10M
                                </p>
                            </div>
                            <div class="tip">
                                <i class="el-icon-warning"></i>
                                请务必提供真实信息，公司有权自行或委托第三方，审查提供的信息是否真实、有效。若提供虚假信息，由此带来的后果由提供方承担。
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
            <div
                class="hline"
                style="position:absolute; width:100%; height:15px; background:#f8fafb;left:0;"
            ></div>
            <el-form
                :model="form"
                :rules="applyrules"
                ref="applyForm"
                label-width="135px"
                class="demo-ruleForm"
            >
                <div class="form">
                    <h3>企业信息</h3>
                    <el-form-item
                        label="企业名称"
                        prop="name"
                    >
                        <el-input
                            v-model="form.name"
                            placeholder="请输入单位证件登记的名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="统一社会信用代码"
                        prop="uscc"
                    >
                        <el-input
                            v-model="form.uscc"
                            placeholder="请输入统一的社会信用代码或组织机构代码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="法定代表人"
                        prop="legal"
                    >
                        <el-input
                            v-model="form.legal"
                            placeholder="请输入法定代表人姓名"
                        ></el-input>
                    </el-form-item>
                </div>
                    <!-- <el-form-item
                        label="申请人账号"
                        prop="userAccount"
                    >
                        <el-input
                            v-model="userAccount"
                            placeholder="请输入申请人账号"
                            disabled
                        ></el-input>
                    </el-form-item> -->
                <div
                    class="hline"
                    style="position:absolute; width:100%; height:15px; background:#f8fafb;left:0;"
                ></div>
                <div class="form">
                    <h3>申请人信息</h3>
                    <el-form-item
                        label="申请人姓名："
                        prop="contactsName"
                    >
                        <el-input
                            v-model="form.contactsName"
                            placeholder="请输入申请人姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="申请人身份证号："
                        prop="contactsIdCard"
                    >
                        <el-input
                            v-model="form.contactsIdCard"
                            placeholder="请输入申请人身份证号"
                        ></el-input>
                    </el-form-item>
                    <p class="form-item-tip"><i class="el-icon-warning"></i>手机号的运营商实名信息需为申请人本人</p>
                    <el-form-item
                        label="申请人手机号："
                        prop="contactsPhone"
                    >
                        <el-input
                            v-model="form.contactsPhone"
                            placeholder="请输入申请人手机号"
                        ></el-input>
                    </el-form-item>
                    <div class="yzm-item">
                        <el-form-item
                            label="验证码:"
                            prop="code"
                        >
                            <el-input
                                v-model="form.code"
                                placeholder="短信验证码"
                            ></el-input>
                        </el-form-item>
                        <span
                            :disabled="disabled"
                            @click="getVerificationCode"
                            >{{ yzmtext }}</span
                        >
                    </div>
                    <div class="submit">
                        <span @click="onSubmit('applyForm')">提交</span>
                    </div>
                </div>
            </el-form>
        </div>
        <div class="zhe" v-if="progress">
            <div class="progress">
                <el-progress
                    type="circle"
                    :percentage="percentage"
                ></el-progress>
            </div>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="successDia"
            width="30%"
            top="27vh"
            class="copyDialog"
            center
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
        >
            <div class="dialog-cnt">
                <h3><i class="el-icon-success"></i></h3>
                <div class="fontCnt">
                    <h4>企业基础信息认证成功!</h4>
                    <!-- <p>如需使用电子签名（壹签）服务，请继续认证</p> -->
                </div> 
            </div>
            
            <div slot="footer" class="dialog-footer">
                <span class="overBtn" @click="over">返回</span>
                <!-- <span class="nextBtn" @click="goOn">继续认证</span> -->
            </div>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="errorDia"
            width="40%"
            top="27vh"
            class="copyDialog"
            center
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
        >
            <div class="dialog-cnt">
                <h3><i class="el-icon-error"></i></h3>
                <div class="fontCnt">
                    <h4>认证失败</h4>
                    <p>{{ errorMessage }}</p>
                    <div class="tip" v-if="errorTip">注意：手机号的运营商实名信息需为申请人本人</div>
                </div> 
            </div>
            
            <div slot="footer" class="dialog-footer">
                <span class="overBtn" @click="errorDia=false">返回修改</span>
            </div>
        </el-dialog>
        <div id="captcha-element"></div>
    </el-row>
</template>

<script>
import {
    businessUploadInfo,
    ocrBusinessLicense,
    ordinaryApply,
} from "@http/user_center/realName";
import {sendMsg} from '@http/user_center/realName'
import { identification } from "@http/user_center/userInfo";
import NoTrace from '@/utils/noTrace';
var interval = null;
export default {
    data() {
        var vuscc = (rule, value, callback) => {
            if (!/^[A-Za-z0-9-]{6,40}$/.test(value)) {
                callback(new Error("统一社会信用代码格式不正确"));
            }
            callback();
        };
        var vphone = (rule, value, callback) => {
            if (!/^1[23456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式不正确"));
            }
            callback();
        };
        var space=(rule, value, callback) => {
            if (value.toString().replace(/\s/g,"")=='') {
                callback(new Error("输入内容不能全为空格"));
            }
            callback();
        };
        return {
            successDia:false,
            errorDia:false,
            errorMessage:'',
            errorTip:false,
            userAccount: this.$getlocalStorage("userData").loginName,
            form: {
                name: "",
                uscc: "",
                legal: "",
                businessUrl: "",
                sourceType: 975260,
                contactsName:"",
                contactsIdCard:"",
                contactsPhone:"",
                code:"",
            },
            applyrules: {
                name: [
                    {
                        required: true,
                        message: "请输入单位证件登记的名称",
                        trigger: "blur",
                    },
                    { min:1, max: 80, message: '输入长度不能大于80', trigger: 'blur' },
                    { validator: space, trigger: "blur" },
                ],
                uscc: [
                    {
                        required: true,
                        message: "请输入统一的社会信用代码或组织机构代码",
                        trigger: "blur",
                    },
                    { min:1, max: 50, message: '输入长度不能大于50', trigger: 'blur' },
                    { validator: vuscc, trigger: "blur" },
                ],
                legal: [
                    {
                        required: true,
                        message: "请输入法定代表人姓名",
                        trigger: "blur",
                    },
                    { min:1, max: 50, message: '输入长度不能大于50', trigger: 'blur' },
                    { validator: space, trigger: "blur" },
                ],
                contactsName: [
                    {
                        required: true,
                        message: "请输入申请人姓名",
                        trigger: "blur",
                    },
                    { min:1, max: 20, message: '输入长度不能大于20', trigger: 'blur' },
                    { validator: space, trigger: "blur" },
                ],
                contactsIdCard: [
                    { required: true, message: "请输入申请人身份证号", trigger: "blur" },
                    { min:1, max: 50, message: '输入长度不能大于50', trigger: 'blur' },
                ],
                contactsPhone: [
                    {
                        required: true,
                        message: "请输入申请人手机号",
                        trigger: "blur",
                    },
                    { validator: vphone, trigger: "blur" },
                ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                    { validator: space, trigger: "blur" },
                ],
            },
            fil: {},
            usccUrl: "",
            percentage: 0,
            currentRate: 0,
            progress: false,
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 60,
            nvc:'',
        };
    },

    components: {},

    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },

    created() {
        identification().then((res) => {
            let status = res.authenticationStatus;
            if(status!==-1 && status!==5){
                this.$router.replace({
                    path:"/userCenter/AuthenticationName",
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    },

    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },

    methods: {
        chooseFile() {
            let that = this;
            let inputDOM = this.$refs.inputer;
            this.fil = inputDOM.files;
            let size = Math.floor(this.fil[0].size);
            let name = inputDOM.files[0].name;
            let index = name.lastIndexOf(".");
            let Format = name.substring(index);
            let arry_format = [".jpg", ".jpeg", ".png", ".bmp"];
            if (arry_format.indexOf(Format) == "-1") {
                this.$msg("文件格式不符合要求");
                this.fil = {};
                this.$refs.inputer.value = null;
                return false;
            }
            if (size > 10 * 1024 * 1000) {
                this.$msg("文件大小不能大于10M");
                this.fil = {};
                this.$refs.inputer.value = null;
                return false;
            }
            businessUploadInfo().then((res) => {
                this.$request({
                    method: "PUT",
                    url: res.uploadUrl,
                    data: that.fil[0].slice(0, that.fil[0].size),
                    timeout: 86400000,
                    headers: {
                        "content-type": "application/octet-stream",
                    },
                    onUploadProgress: function(progressEvent) {
                        that.progress = true;
                        that.percentage =
                            Math.floor(
                                (progressEvent.loaded /
                                    progressEvent.total) *
                                    100
                            ) | 0;
                    },
                }).then(async () => {
                    that.usccUrl = res.viewUrl;
                    try {
                        let {
                            companyName,
                            creditCode,
                            legalPerson,
                        } = await ocrBusinessLicense({
                            businessUrl: res.viewUrl,
                        });
                        that.form.name = companyName;
                        that.form.uscc = creditCode;
                        that.form.legal = legalPerson;
                        that.form.businessUrl = res.businessUrl;
                        that.form.sourceType =
                            that.$getlocalStorage("queryData")
                                ?.sourceType ||
                            this.$getlocalStorage("queryData")
                                ?.clientId ||
                            975260;
                        that.$refs.applyForm.validateField("name");
                        that.$refs.applyForm.validateField("uscc");
                        that.$refs.applyForm.validateField("legal");
                        that.progress = false;
                        setTimeout(() => {
                            that.percentage = 0;
                            that.currentRate = 0;
                        }, 2000);
                    } catch (error) {
                        that.$refs.inputer.value=null;
                        that.usccUrl = '';
                        that.form.businessUrl='';
                        that.progress = false;
                        setTimeout(() => {
                            that.percentage = 0;
                            that.currentRate = 0;
                        }, 2000);
                    }
                }).catch((err) => {
                    console.log(err);
                });
            })
        },
        onSubmit(form) {
            let that = this;
            this.errorTip=false;
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if (!that.form.businessUrl) {
                        that.$msg("请上传企业营业执照");
                        return false;
                    }
                    this.$TsaWebTrace.post({
                        data: {
                            "eventId": 35015,
                        },
                    });
                    ordinaryApply(that.form).then((res) => {                            
                            this.successDia=true;
                            this.$store.dispatch('userInfo/setLawyerInfo', {})
                            zhuge.track('用户中心_企业认证成功', {'渠道': this.channelCodeValue,'用户行为':'实名认证'})
                    }).catch((err) => {
                        if(err.status === 500){
                            this.$msg('服务异常')
                            return
                        }
                        this.errorMessage=err.data.message
                        if(err.data.code==999){
                            this.errorTip=true;
                        }
                        this.errorDia=true;
                    });
                }
            });
        },
        over(){
            if(this.$getlocalStorage("queryData")?.from=='lawcase'){
                zhuge.track('律师咨询_实名认证成功',{'端':'PC'},()=>{
                    this.$store.dispatch('userInfo/setLawyerInfo', {})
                    if(this.$getlocalStorage("queryData")?.to){
                      window.location.href =`${process.env.VUE_APP_LAWCASE}/userCenter/authentication?to=${this.$getlocalStorage("queryData").to}&randomKey=${this.$getlocalStorage("queryData").randomKey || ''}`
                    }else{
                        window.location.href =`${process.env.VUE_APP_LAWCASE}/userCenter/authentication`
                    }                           
                })
            }else{
                this.$router.replace({
                    path:"/userCenter/AuthenticationName",
                });
            }
        },
        goOn(){
            this.$router.replace({
                path:"/userCenter/realName/enterpriseAuthorize",
            });
        },
        async getVerificationCode() {
            var that = this;
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35022,
                    "logParam":{
                        'phone':that.form.contactsPhone,
                    }
                },
            });
            let { contactsPhone } = that.form;
            if (!contactsPhone) {
                that.$msg("申请人手机号不能为空");
                return false;
            }
            let reg = /^1[23456789]\d{9}$/;
            if (!reg.test(contactsPhone)) {
                that.$msg("手机号格式不正确");
                return false;
            }
            this.getCode();
            that.disabled = true;
            // 开始获取无痕验证码
            NoTrace.start((nvc) => {
                that.nvc = nvc
            }, that.executeFun, {
                phone: that.form.contactsPhone,
                nvc: '',
                afsVersion: 2
            })
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$msg(res.message, "success");
                }catch (err) {
                    reject(err)
                    that.$msg('发送失败')
                    clearInterval(interval);
                    that.yzmtext = "获取验证码";
                    that.disabled = false;
                }
            })
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = 60;
                    that.disabled = false;
                }
            }, 1000);
        },
    },
};
</script>
<style lang="less" scoped>
.mianContent {
    position: relative;
    .back {
        position: absolute;
        right: 30px;
        top: -30px;
        font-size: 14px;
        cursor: pointer;
        &:hover {
            color: #10a0e9;
        }
    }
}

.section {
    padding: 33px 0 41px;
}
.license {
    width: 675px;
    margin: 0 auto;
    dl {
        width: 100%;
        display: flex;
        dt {
            margin-right: 21px;
            .license_area {
                position: relative;
                width: 274px;
                img {
                    width: 274px;
                    height: 168px;
                }
                .uploadfile {
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }
            h6 {
                font-size: 14px;
                margin-top: 20px;
                text-align: center;
                font-weight: 500;
            }
        }
        dd {
            text-align: center;
            .license_title {
                font-size: 16px;
                padding: 13px 0 19px;
            }
            .des {
                line-height: 20px;
                font-size: 14px;
                color: #c1c1c1;
            }
            .tip{
                display: flex;
                color: #F09135;
                font-size: 14px;
                text-align: left;
                margin-top: 13px;
                i{
                    margin-top:3px;
                    margin-right: 5px;
                }
            }
        }
    }
}
.form {
    width: 675px;
    box-sizing: border-box;
    padding-top: 47px;
    padding-right: 150px;
    margin: 0 auto;
    h3{
        font-weight: bold;
        color: #000;
        font-size: 16px;
        margin-bottom: 20px;
    }
    .form-item-tip{
        display: flex;
        color: #F09135;
        font-size: 14px;
        align-items: center;
        i{
            margin-right: 5px;
        }
        &::before{
            content: '';
            display: block;
            width: 135px;
        }
    }
    .yzm-item {
        width: 525px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .yzm-item .el-form-item {
        width: 350px;
    }
    .yzm-item span {
        width: 148px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: #fff;
        color: #3f7df7;
        cursor: pointer;
        border: 1px solid #3f7df7;
        font-size: 14px;
        margin-top: 3px;
        border-radius: 3px;
    }
    .yzm-item span:hover {
        background: #3f7df7;
        color: #fff;
    }
    .yzm-item span[disabled] {
        color: #fff;
        background: #bcbcbc;
        pointer-events: none;
        cursor: inherit;
        border-color: #bcbcbc;
    }
    .submit {
        span {
            display: inline-block;
            width: 130px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            border-radius: 5px;
            border: 1px solid #10a0e9;
            cursor: pointer;
            background: #10a0e9;
            color: #fff;
            margin-bottom: 20px;
            margin-left: 140px;
            opacity: 0.7;
            &:hover {
                opacity: 1;
            }
        }
    }
}
.zhe {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
}

.zhe .progress {
    position: fixed;
    width: 126px;
    height: 126px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99999;
    color: #fff;
    /deep/.el-progress__text {
        color: #fff;
    }
}
/deep/.copyDialog{
    .el-dialog{
        .el-dialog__body{
            padding: 25px;
        }
    }
    .dialog-cnt{
        text-align: center;
    }
    h3{
        margin-bottom: 15px;
        i{
            font-size: 50px;
            &.el-icon-success{
                color:#67C23A;
            }
            &.el-icon-error{
                color:red;
            }
        }
    }
    .fontCnt{
        h4{
            font-size: 18px;
            font-weight: 400;
            color: #333333;
        }
        p{
            margin-top:15px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
        }
        .tip{
            margin-top:15px;
            color: #F09135;
        }
    }
    .dialog-footer{
        display: flex;
        justify-content: space-around;
        span{
            cursor: pointer;
            display: block;
            width: 141px;
            height: 43px;
            text-align: center;
            line-height: 43px;
            box-sizing: border-box;
        }
        .overBtn{
            color: #3F7DF7;
            border:1px solid #3F7DF7;
            &:hover{
                background:#3f7cf709
            }
        }
        .nextBtn{
            background: #3F7DF7;
            color:#fff;
            &:hover{
                background:#2f73fc;
            }
        }
    }
}
</style>
